import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GoogleMapView from "../GoogleMapView";
import useIsMobile from "../../hooks/useIsMobile";
import AffichageRealisationsPresta from "../AffichageRealisationsPresta";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function UserPrestataireForAdmin({ prestataire, userActif }) {
    const dispatch = useDispatch();
    const { user, token } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [localPrestataire, setLocalPrestataire] = useState(prestataire);
    const [localUser, setLocalUser] = useState(userActif);
    const apiUrl = process.env.REACT_APP_API_URL;

    // ❗Ce hook doit être avant tout "return"
    const isMobile = useIsMobile(768);

    const [isUpdateFormInfo, setIsUpdateFormInfo] = useState(false);

    const [activeTab, setActiveTab] = useState("infos");
    const [openAccordion, setOpenAccordion] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [typePhoto, setTypePhoto] = useState(null);

    // 🔥 Seulement maintenant : on peut retourner null
    if (!prestataire) return null;

    const getNameStatut = (idStatut) => {
        switch (idStatut) {
            case "micro-entrepreneur":
                return "Micro-entrepreneur (ME)";
            case "eirl":
                return "Entreprise Individuelle (EI)";
            default:
                return idStatut.toUpperCase();
        }
    };
    const urlImgsMetier = apiUrl + "/api/files/?categorie=metiers&file=";

    const tabList = [
        { id: "infos", label: "Informations personnelles" },
        { id: "entreprise", label: "Entreprise" },
        { id: "presentation", label: "Présentation" },
        { id: "localisation", label: "Localisation" },
        { id: "competences", label: "Compétences" },
        { id: "realisations", label: "Réalisations" },

    ];

    const handlePhotoClick = (typePhoto) => {
        fileInputRef.current?.click();
        setTypePhoto(typePhoto);
    };

    const handleUpdateInfo = async () => {
        try {
            const formData = new FormData();
            formData.append("idUser", userActif.idUser);
            formData.append("mail", localUser.mailUser);
            formData.append("nom", localPrestataire.lastNamePrestataire);
            formData.append("prenom", localPrestataire.firstNamePrestataire);
            formData.append("dateOfBirthRepresentant", localPrestataire.dateNaissancePrestataire);
            formData.append("siteWeb",localPrestataire.siteWeb);
            const response = await fetch(
                `${apiUrl}/api/admin/updatePrestataire`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                    body: formData,

                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Erreur lors de la mise à jour");
            }
            setIsUpdateFormInfo(false);


        } catch (error) {
            console.error(error);
            alert(error.message);
        }
    }

    const handlePhotoChange = async (e) => {
        const file = e.target.files[0];

        if (!file) return;

        try {
            const formData = new FormData();
            formData.append("idPrestataire", localPrestataire.idPrestataire);
            formData.append(typePhoto, file);

            const response = await fetch(
                `${apiUrl}/api/admin/updatePhotoPresta`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                    body: formData,

                }
            );

            const data = await response.json();
            const fileName = data.fileName;

            setLocalPrestataire((prev) => {
                if (typePhoto === "photoProfil") {
                    return {
                        ...prev,
                        photoProfilPrestataire: fileName
                    };
                }

                if (typePhoto === "logoEntreprise") {
                    return {
                        ...prev,
                        logoPrestataire: fileName
                    };
                }

                return prev;
            });
            if (!response.ok) {
                throw new Error(data.error || "Erreur lors de l'upload");
            }



        } catch (error) {
            console.error(error);
            alert(error.message);
        }

        // Permet de sélectionner à nouveau le même fichier
        e.target.value = "";
    };

    return (
        <>
            <div className="profil-wrapper">
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handlePhotoChange}
                />
                {/* Desktop Tabs */}
                {!isMobile && (
                    <div style={{ display: "flex", gap: "12px", margin: "auto", marginTop: "15px", justifyContent: "center" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab.id}
                                style={{
                                    padding: "8px 14px",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                    background: activeTab === tab.id ? "#007bff" : "#f1f1f1",
                                    color: activeTab === tab.id ? "white" : "#333",
                                    border: "none",
                                }}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {tab.label}
                            </button>
                        ))}

                    </div>
                )}

                {/* Mobile Dropdown */}
                {isMobile && (
                    <div style={{ marginTop: "20px", marginBottom: "15px" }}>
                        <button
                            style={{ padding: "10px", borderRadius: "6px", background: "#f1f1f1", width: "100%" }}
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            {tabList.find((t) => t.id === activeTab)?.label} ▾
                        </button>
                        {mobileMenuOpen && (
                            <div style={{ marginTop: "10px", border: "1px solid #ddd", borderRadius: "6px", background: "#fafafa" }}>
                                {tabList.map((tab) => (
                                    <div
                                        key={tab.id}
                                        style={{ padding: "12px", cursor: "pointer" }}
                                        onClick={() => {
                                            setActiveTab(tab.id);
                                            setMobileMenuOpen(false);
                                        }}
                                    >
                                        {tab.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                <div className="profil-content">
                    {activeTab === "infos" && (
                        <div className="profil-section-card">
                            {localPrestataire?.photoProfilPrestataire && (
                                <div className="profil-photo-container">
                                    <img
                                        className="profil-photo"
                                        src={
                                            apiUrl +
                                            "/api/files/?categorie=photosPrestataires&file=" +
                                            localPrestataire?.photoProfilPrestataire +
                                            "&t=" + Date.now()
                                        }
                                        alt="Photo de profil"

                                    />
                                </div>
                            )}
                            <button className="btn-primary" onClick={() => handlePhotoClick("photoProfil")}>{prestataire.photoProfilPrestataire ? "MODIFIER LA " : "AJOUTER UNE "}PHOTO DE PROFIL</button>


                            {!isUpdateFormInfo ? (
                                <>
                                    <p>id : {localUser.idUser}</p>
                                    <p><strong>Mail :</strong> {localUser.mailUser}</p>

                                    <p>
                                        <strong>Nom :</strong> {localPrestataire.lastNamePrestataire}
                                    </p>

                                    <p>
                                        <strong>Prénom :</strong> {localPrestataire.firstNamePrestataire}
                                    </p>

                                    <p>
                                        <strong>Date de naissance :</strong>{" "}
                                        {localPrestataire.dateNaissancePrestataire}
                                    </p>

                                    <p>
                                        <strong>Téléphone :</strong>{" "}
                                        {localPrestataire.telephonePrestataire}
                                    </p>
                                    {
                                        localPrestataire.siteWeb !== "" && (
                                            <p>
                                                <strong>Site Web :</strong>{" " + localPrestataire.siteWeb}
                                            </p>
                                        )
                                    }


                                    <button
                                        className="btn-primary"
                                        onClick={() => setIsUpdateFormInfo(true)}
                                    >
                                        MODIFIER
                                    </button>
                                </>
                            ) : (
                                <>
                                    <div className="form-group">
                                        <label>Mail</label>
                                        <input
                                            type="email"
                                            value={localUser.mailUser || ""}
                                            onChange={(e) =>
                                                setLocalUser({
                                                    ...user,
                                                    mailUser: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Nom</label>
                                        <input
                                            type="text"
                                            value={localPrestataire.lastNamePrestataire || ""}
                                            onChange={(e) =>
                                                setLocalPrestataire({
                                                    ...prestataire,
                                                    lastNamePrestataire: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Prénom</label>
                                        <input
                                            type="text"
                                            value={localPrestataire.firstNamePrestataire || ""}
                                            onChange={(e) =>
                                                setLocalPrestataire({
                                                    ...prestataire,
                                                    firstNamePrestataire: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Date de naissance</label>
                                        <input
                                            type="date"
                                            value={localPrestataire.dateNaissancePrestataire || ""}
                                            onChange={(e) =>
                                                setLocalPrestataire({
                                                    ...prestataire,
                                                    dateNaissancePrestataire: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Téléphone</label>
                                        <input
                                            type="tel"
                                            value={localPrestataire.telephonePrestataire || ""}
                                            onChange={(e) =>
                                                setLocalPrestataire({
                                                    ...prestataire,
                                                    telephonePrestataire: e.target.value
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Site Web</label>
                                        <input
                                            type="text"
                                            value={localPrestataire.siteWeb || ""}
                                            onChange={(e) =>
                                                setLocalPrestataire({
                                                    ...prestataire,
                                                    siteWeb: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                    <button
                                        className="btn-primary"
                                        onClick={handleUpdateInfo}
                                    >
                                        VALIDER
                                    </button>

                                    <button
                                        className="btn-secondary"
                                        onClick={() => setIsUpdateFormInfo(false)}
                                    >
                                        ANNULER
                                    </button>
                                </>
                            )}



                        </div>
                    )}

                    {activeTab === "entreprise" && (
                        <div className="profil-section-card">
                            {localPrestataire?.logoPrestataire && (
                                <div className="profil-photo-container">
                                    <img
                                        className="profil-photo"
                                        src={
                                            apiUrl +
                                            "/api/files/?categorie=logos&file=" +
                                            localPrestataire?.logoPrestataire +
                                            "&t=" + Date.now()
                                        }
                                        alt="Logo"
                                    />
                                </div>
                            )}
                            <button className="btn-primary" onClick={() => handlePhotoClick("logoEntreprise")}>{prestataire.logoPrestataire ? "MODIFIER LE " : "AJOUTER UN "}LOGO</button>
                            <p><strong>Raison sociale :</strong> {prestataire.raisonSocialePrestataire}</p>
                            <p><strong>Secteur d'activité principal :</strong> {prestataire.secteur.labelSecteur}</p>
                            <p><strong>Statut :</strong> {getNameStatut(prestataire.statutPrestataire)}</p>
                            <p><strong>SIRET :</strong> {prestataire.siretPrestataire}</p>
                            {
                                !prestataire.isExempteTva && (
                                    <p><strong>TVA :</strong> {prestataire.numTvaPrestataire}</p>
                                )
                            }
                            {
                                prestataire.isExempteTva && (
                                    <p>Non assujetti à la TVA (Article 293 B du CGI)</p>
                                )
                            }



                        </div>
                    )}
                    {activeTab === "presentation" && (
                        <div className="profil-section-card">

                            <p><strong>Présentation :</strong> {prestataire.descriptionPrestataire}</p>
                            <p><strong>Intervention d'urgence 24h/24 7j/7 :</strong> {prestataire.isEmergencyInterventionPossible ? "OUI" : "NON"}</p>

                        </div>
                    )}
                    {activeTab === "localisation" && (
                        <div className="profil-section-card">

                            <p><strong>Adresse :</strong> {prestataire.adressePrestataire}</p>
                            <p><strong>Code postal :</strong> {prestataire.codePostalPrestataire}</p>
                            <p><strong>Ville :</strong> {prestataire.villePrestataire}</p>
                            <p><strong>Pays :</strong> France</p>
                            <p><strong>Travail à distance uniquement :</strong> {prestataire.isDistanceOnly ? "OUI" : "NON"}</p>
                            {
                                !prestataire.isDistanceOnly && (
                                    <p><strong>Rayon d'intervention :</strong>{prestataire.rayonIntervention === 1000000 ? "Illimité" : " " + prestataire.rayonIntervention + " km"}</p>
                                )
                            }
                            <GoogleMapView origin={{ lat: prestataire.latitudePrestataire, lng: prestataire.longitudePrestataire }} />


                        </div>
                    )}
                    {
                        activeTab === "competences" && (
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    marginTop: "20px",
                                }}
                            >
                                {prestataire.competences.map((comp) => (
                                    <div
                                        key={comp.idMetier}
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "8px",
                                            borderRadius: "8px",
                                            width: "100px",
                                            textAlign: "center",
                                            position: "relative",
                                        }}
                                    >
                                        <img
                                            src={urlImgsMetier + comp.iconMetier}
                                            alt="icone métier"
                                            style={{ width: "40px", height: "40px" }}
                                        />
                                        <p style={{ fontSize: "13px" }}>{comp.labelMetier}</p>


                                    </div>
                                ))}
                            </div>
                        )
                    }
                    {
                        activeTab === "realisations" && (
                            <AffichageRealisationsPresta prestataire={prestataire} />
                        )
                    }
                </div>
            </div>


        </>
    );
}
